import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';
import MultiHalfText from '../../../components/MultiHalfText';

export default function Page07({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<MultiHalfText first='Bottom Heavy / Core' second='Workout 05' mt={true} />
			<RoundScreen
				isNumbered={false}
				rounds={[
					[
						{
							header: '(A) Glutes / Hamstrings',
							value: 'Donkey Kicks',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 12',
						},
						{
							header: 'ABS / Core',
							value: 'Crunches',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec',
						},
					],
					[
						{
							header: '(A) Glutes / Hamstrings',
							value: 'Air Squat',
						},
						{
							header: 'Sets / Reps',
							value: '3 x 10',
						},
						{
							header: 'ABS / Core',
							value: 'Bicycles',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec',
						},
					],
					[
						{
							header: '(A) Glutes / Hamstrings',
							value: 'Curtsey Lunges',
						},
						{
							header: 'Sets / Reps',
							value: '3 x 10',
						},
						{
							header: 'ABS / Core',
							value: 'Leg-Lifts',
						},
						{
							header: 'Sec / Minutes',
							value: '25 sec',
						},
					],
					[
						{
							header: '(A) Glutes / Hamstrings',
							value: 'Reverse Lunges',
						},
						{
							header: 'Sets / Reps',
							value: '3 x 12',
						},
						{
							header: 'ABS / Core',
							value: 'Toe Touches',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec',
						},
					],
					[
						{
							header: '(A) Glutes / Hamstrings',
							value: 'Kneeling Hip Thrust w / (DB) (optional)',
						},
						{
							header: 'Sets / Reps',
							value: '3 x 12',
						},
						{
							header: 'ABS / Core',
							value: '6 inches',
						},
						{
							header: 'Sec / Minutes',
							value: '1 min',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
